









































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import { AppModule } from '@/store/modules/app';
import { updateAccountPassword } from '@/api/users';
import { formatApiError } from '@/utils/index';
import { translateRouteTitle } from '@/utils/permission';

type ItemType = {
  text: string;
  value: string;
};

@Component({
  name: 'SettingPassword',
  components: {
    MaterialCard,
  },
})
export default class extends Vue {
  private loading = true;
  private valid = false;
  private password = '';
  private showPassword = false;
  private passwordRules: ((v: string) => boolean | string)[] = [];
  private dialog = false;
  private dialogConfirmHandler = this.resetDialog;
  private dialogTextTitle = '';
  private dialogTextFooter = '';

  get isDialogFullscreen() {
    return false && this.$vuetify.breakpoint.smAndDown;
  }

  get canUpdatePassword() {
    return this.valid;
  }

  mounted() {
    this.loadRules();
    this.loading = false;
  }

  private loadRules() {
    this.passwordRules = [
      (v: string) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Password'),
        }) as string),
    ];
  }

  private resetDialog() {
    this.dialog = false;
    this.dialogTextTitle = '';
    this.dialogTextFooter = '';

    this.$nextTick(() => {
      this.dialogConfirmHandler = this.resetDialog;
    });
  }

  private showDialogForUpdatePassword() {
    this.dialogTextTitle = `${this.translateRouteTitle(
      this.$route.meta.title
    )}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.updatePassword();
    };
    this.dialog = true;
  }

  private showDialogForReset() {
    this.dialogTextTitle = `${this.$t('Reset')}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.reset();
    };
    this.dialog = true;
  }

  private reset() {
    this.password = '';
    this.showPassword = false;
  }

  private async updatePassword() {
    this.loading = true;
    AppModule.StartProgress();

    try {
      await updateAccountPassword({
        password: this.password,
      });
      this.$toast.success(
        this.$t('Succeeded {do}', {
          do: (this.translateRouteTitle(
            this.$route.meta.title
          ) as string).toLowerCase(),
        }) as string,
        {
          icon: this.$route.meta.icon,
        }
      );
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.translateRouteTitle(
            this.$route.meta.title
          ) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }

    this.reset();
    AppModule.StopProgress();
    this.loading = false;
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
